import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

//Components
import ConsultaRegrasVersoes from '../../../components/RegrasVersoes/ConsultaRegrasVersoes';

//Api
import regraVersaoSistema_api from '../../../api/regraVersaoSistema_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { abrirConsultaPublica } from '../Cadastros/RegrasEVersoes/helpers/regrasEVersoes';

//Context
import { useAuth } from '../../../context/auth';

// Consulta dentro do sistema, liberada a todos os usuários autenticados (CE-3522):
// aparece no menu e não exige permissão de funcionalidade.
export default function RegrasEVersoesSistema() {

    //Estado de controle da lista de regras e versões publicadas
    const [regrasVersoes, setRegrasVersoes] = useState([]);

    //Pegando o estado de controle do loading na tela
    const { setLoading } = useAuth();

    const loadRegrasVersoes = () => {
        setLoading(true);
        regraVersaoSistema_api.getListAtivos()
            .then(response => setRegrasVersoes(response.data))
            .catch(e => showMessage("Erro", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    //Busca o detalhe do item selecionado para abrir no modal de visualização
    const carregarDetalhe = (item) => {
        setLoading(true);
        return regraVersaoSistema_api.getItem(item.id)
            .then(response => response.data)
            .catch(e => {
                showMessage("Erro", e.message, "error", null);
                return null;
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadRegrasVersoes();
    }, []);

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Regras e Versões do Sistema</h4>
                <Button color='primary' onClick={abrirConsultaPublica} title='Abre a consulta pública em uma nova aba'>
                    <FontAwesomeIcon icon={faUpRightFromSquare} /> Consulta pública
                </Button>
            </div>
            <ConsultaRegrasVersoes itens={regrasVersoes} carregarDetalhe={carregarDetalhe} />
        </>
    )
}
